import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css, withTheme } from 'styled-components';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import { fetchBus } from '../../components/Bus/actions';
import Icon from '../../components/Icon';
import Loader from '../../components/Loader';
import Stepper from '../../components/Stepper';
import { clearState } from '../../localStorage';
import { getProp, __ } from '../../utilities';
import Connections from '../Connections';
import {
  connectionByIdSelector,
  paramsSelector,
} from '../Connections/selectors';
import { locale } from '../LocaleProvider';
import Login from '../Login';
import { getMe } from '../Login/actions';
import {
  userDetailIsFetchingSelector,
  userDetailSelector,
} from '../Login/selectors';
import Passengers from '../Passengers';
import { checkSeatingInBus } from '../Pooling/actions';
import { isFreeSeatingSelector, seatingsSelector } from '../Pooling/selectors';
import Reservation from '../Reservation';
import {
  firstWayConnectionIdSelector,
  isSeatingInWaysInSectorsSelector,
  secondWayConnectionIdSelector,
} from '../Reservation/selectors';
import ReservationConnectionForm from '../ReservationConnectionForm';
import Summary from '../Summary';
import SummaryPage from '../SummaryPage';
import {
  errorAlert,
  goToStep,
  loadMessages,
  loadOtherContentById,
  setParamsToStep,
  setTicketId,
} from './actions';
import { alertSelector, currentStepSelector } from './selectors';

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const LoaderWrapper = styled.div`
  margin: 2rem 0;
`;

const Background = styled.div`
  flex: 1 0 0;
  padding: ${rem(64)} 0;
  padding-bottom: 5rem;
  background-color: #06377b;
  background-image: url(${process.env.REACT_APP_API_BASE_URL}/public/img/assets/background-header.png);
  background-repeat: no-repeat;
  background-position: top center;
  @media screen and (max-width: 1480px) {
    padding: ${rem(16)} 0;
    padding-bottom: 2rem;
  }
`;

const LogoLink = styled.a`
  display: block;
  @media screen and (max-width: 486px) {
    margin-top: ${rem(10)};
    img {
      width: ${rem(120)};
    }
  }
`;

const StyledStepper = styled(Stepper)`
  border-radius: ${rem(4)} ${rem(4)} 0 0;
`;

const CancelLink = styled.a`
  display: block;
  margin-right: auto;
  display: flex;
  align-items: center;
  margin-left: ${rem(18)};
  text-decoration: none;
  color: ${({ theme }) => theme.color.font.primary};
  &:hover {
    text-decoration: underline;
  }
  @media screen and (max-width: 486px) {
    display: none;
  }
`;

const Logo = styled.img``;

const Container = styled.div`
  max-width: ${rem(1420)};
  margin: auto;
  @media screen and (max-width: 1480px) {
    margin: 0 ${rem(30)};
  }
  @media screen and (max-width: 800px) {
    margin: 0 1rem;
  }
`;

const Content = styled.div`
  background: #eee;
  border-radius: 0 0 ${rem(4)} ${rem(4)};
`;

const HeaderWrapper = styled.div`
  display: flex;
  height: ${rem(83)};
  min-height: ${rem(83)};
  @media screen and (max-width: 486px) {
    height: auto;
    min-height: ${rem(110)};
  }
`;

const Header = styled(Container)`
  display: flex;
  flex: 1 0 0;
  align-items: center;
  @media screen and (max-width: 486px) {
    flex-direction: column;
  }
`;

const Languages = styled.div`
  ${({ borderLeft }) =>
    borderLeft &&
    css`
      border-left: ${rem(1)} solid ${({ theme }) => theme.color.font.primary};
    `} margin-left: ${rem(5)};
  a {
    display: inline-block;
    width: ${rem(30)};
    margin-left: ${rem(4)};
    &:hover {
      img {
        border: ${rem(2)} solid ${({ theme }) => theme.color.primary};
      }
    }
  }
  img {
    border: ${rem(2)} solid transparent;
    position: relative;
    width: 100%;
    height: auto;
    transition: 0.2s border;
  }
`;

const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${rem(10)};
`;

const UserInfo = styled.div`
  text-align: right;
  font-size: ${rem(14)};
  a {
    color: ${({ theme }) => theme.color.font.primary};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const HeaderSummary = styled.div`
  background-color: #dedddd;
  padding: ${rem(10)};
`;

const SummaryTitle = styled.div`
  text-align: center;
  font-size: ${rem(20)};
  margin-bottom: ${rem(10)};
`;

class App extends Component {
  constructor(props) {
    super(props);
    this.stepBack = this.stepBack.bind(this);
    this.handleClickStep = this.handleClickStep.bind(this);
  }

  componentWillMount() {
    const {
      dispatch,
      location: { query },
    } = this.props;
    dispatch(getMe());
    dispatch(loadMessages());
    dispatch(loadOtherContentById('RESERVATION_LOGIN_PAGE'));
    dispatch(loadOtherContentById('GDPR_LINK'));
    dispatch(loadOtherContentById('RESERVATION_REGISTER'));
    dispatch(loadOtherContentById('RESERVATION_WITHOUT_LOGIN'));
    if (query.ticketType === 'B') {
      this.props.dispatch(
        setParamsToStep({ for: 'passengers', info: [{ name: '' }] }),
      );
      const ticketId = getProp(query, ['ticketId'], '');
      if (ticketId !== '') {
        dispatch(setTicketId(ticketId));
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { step: nextStep } = nextProps;

    const { step } = this.props;

    if (step !== nextProps.step) {
      window.scrollTo(0, 0);
    }

    if (nextStep !== 'firstWay' && step !== nextStep) {
      this.checkPooling(nextProps);
    }
  }

  componentDidCatch() {
    clearState();
    window.location = `${process.env.REACT_APP_API_BASE_URL}/`;
  }

  getSteps() {
    const {
      location: { query },
      isSeating,
      step,
      user,
    } = this.props;

    const steps = {
      firstWay: {
        title:
          query.ticketType === 'B' ? __('Spiatočná cesta') : __('Prvá cesta'),
      },
      secondWay: {
        title: __('Druhá cesta'),
      },
      login: {
        title: __('Prihlásenie'),
      },
      passengers: {
        title: __('Cestujúci'),
      },
      reservations: {
        title: __('Miestenky'),
      },
      summary: {
        title: __('Sumár'),
      },
    };

    // odstranime nerelevantne kroky
    let blacklistSteps = [];
    if (query.ticketType === 'R') {
      //
    } else if (query.ticketType === 'B') {
      // vyberame spiatocnu cestu pre open listok
      blacklistSteps = ['secondWay', 'passengers', 'login'];
    } else {
      blacklistSteps = ['secondWay'];
    }
    if (!isSeating) {
      // ak nemozeme vyberat sedenie, nebudeme ho zobrazovat
      blacklistSteps = [...blacklistSteps, 'reservations'];
    }
    if (step === 'firstWay') {
      // ak sa preklikneme na prvy krok, nevieme, ci existuje sedenie
      blacklistSteps = [...blacklistSteps, 'reservations'];
    }
    if (user !== null) {
      blacklistSteps = [...blacklistSteps, 'login'];
    }

    return Object.keys(steps)
      .map(stepKey =>
        blacklistSteps.includes(stepKey)
          ? false
          : { ...steps[stepKey], value: stepKey },
      )
      .filter(currentStep => currentStep);
  }

  checkPooling(props) {
    const {
      isSectorFree,
      isSeatFree,
      firstWayId,
      secondWayId,
      dispatch,
    } = props;

    if (firstWayId) {
      const { connectionsById } = props;
      getProp(connectionsById, [firstWayId, 'sectors'], []).forEach(sector => {
        const {
          from_id_bus_stop: from,
          to_id_bus_stop: to,
          busses,
          id_dps: idDps,
          id_prejazd: idPrejazd,
        } = sector;
        dispatch(fetchBus(from, to, busses[0].id_bus));
        dispatch(checkSeatingInBus(idDps, idPrejazd, busses[0].id_bus));
      });
    }
    if (secondWayId) {
      const { connectionsById } = props;
      getProp(connectionsById, [secondWayId, 'sectors'], []).forEach(sector => {
        const {
          from_id_bus_stop: from,
          to_id_bus_stop: to,
          busses,
          id_dps: idDps,
          id_prejazd: idPrejazd,
        } = sector;
        dispatch(fetchBus(from, to, busses[0].id_bus));
        dispatch(checkSeatingInBus(idDps, idPrejazd, busses[0].id_bus));
      });
    }
    if (isSectorFree && isSectorFree.length > 0) {
      isSectorFree.forEach(item => {
        this.props.dispatch(
          errorAlert(
            `${__('Spojenie zo zastávky')} ${item.from_bus_stop} ${__(
              'do zastávky',
            )} ${item.to_bus_stop} ${__('neobsahuje dostatok voľných miest!')}`,
          ),
        );
      });
    }
    if (isSeatFree.length > 0) {
      isSeatFree.forEach(item => {
        this.props.dispatch(
          errorAlert(
            `${__('Miestenka číslo')} ${item.seat}${__(
              ', ktorú ste si vybrali v spojení zo zastávky',
            )} ${item.from_bus_stop} ${__('do zastávky')} ${
              item.to_bus_stop
            }${__(', je už obsadená!')}`,
          ),
        );
      });
    }
  }

  handleClickStep(index) {
    this.props.dispatch(goToStep(index));
  }

  stepBack() {
    let i = null;
    const avaSteps = this.getSteps();
    avaSteps.forEach((s, index) => {
      if (s.value === this.props.step) {
        i = index;
      }
    });
    this.props.dispatch(goToStep(avaSteps[i - 1].value));
  }

  render() {
    const { user, userIsFetching } = this.props;
    let content = <div />;

    switch (this.props.step) {
      case 'firstWay': {
        content = <Connections way={1} />;
        break;
      }
      case 'secondWay': {
        content = <Connections way={2} />;
        break;
      }
      case 'login': {
        content = <Login backStep={this.stepBack} />;
        break;
      }
      case 'passengers': {
        content = <Passengers backStep={this.stepBack} />;
        break;
      }
      case 'reservations': {
        content = <Reservation backStep={this.stepBack} />;
        break;
      }
      case 'summary': {
        content = <SummaryPage backStep={this.stepBack} />;
        break;
      }
      default: {
        break;
      }
    }

    let headerContent = null;
    if (this.props.step === 'firstWay') {
      headerContent = <ReservationConnectionForm />;
    } else if (this.props.step !== 'summary') {
      headerContent = (
        <HeaderSummary>
          <SummaryTitle>{__('Prehľad objednávky')}</SummaryTitle>
          <Summary small />
        </HeaderSummary>
      );
    }

    let websiteLink = `${process.env.REACT_APP_API_BASE_URL}/`;
    if (locale.lang !== 'sk') {
      websiteLink = `${process.env.REACT_APP_API_BASE_URL}/${locale.lang}`;
    }

    if (userIsFetching) {
      return (
        <Wrapper>
          <LoaderWrapper>
            <Loader size="xxl" text={__('Prosím počkajte')} />
          </LoaderWrapper>
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <HeaderWrapper>
          <Header>
            <LogoLink href={websiteLink}>
              <Logo
                src={`${
                  process.env.REACT_APP_API_BASE_URL
                }/public/img/assets/eurobus-logo.svg`}
              />
            </LogoLink>
            <CancelLink href={websiteLink}>
              <Icon
                color={this.props.theme.color.font.primary}
                name="chevron-left"
                size="s"
              />
              <span style={{ marginLeft: '0.5rem' }}>
                {__('Naspäť na stránku eurobus.sk')}
              </span>
            </CancelLink>
            <UserContainer>
              <UserInfo>
                {user ? (
                  <div>
                    <a
                      href={`${process.env.REACT_APP_API_BASE_URL}/club/user`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {user.username}
                      &#160;
                      {user.surname}
                    </a>
                    <br />
                    <a
                      href={`${
                        process.env.REACT_APP_API_BASE_URL
                      }/club/auth/logout`}
                    >
                      {__('Odhlásiť')}
                    </a>
                  </div>
                ) : (
                  <div />
                )}
              </UserInfo>
              <Languages borderLeft={!!user}>
                <a href="/reservation">
                  <img
                    src={`${
                      process.env.REACT_APP_API_BASE_URL
                    }/public/img/assets/flags/sk.png`}
                    alt="Slovenčina"
                  />
                </a>
                <a href="/reservation?lang=en">
                  <img
                    src={`${
                      process.env.REACT_APP_API_BASE_URL
                    }/public/img/assets/flags/en.png`}
                    alt="English"
                  />
                </a>
                <a href="/reservation?lang=ua">
                  <img
                    src={`${
                      process.env.REACT_APP_API_BASE_URL
                    }/public/img/assets/flags/ua.png`}
                    alt="English"
                  />
                </a>
              </Languages>
            </UserContainer>
          </Header>
        </HeaderWrapper>
        <Background>
          <Container>
            <StyledStepper
              steps={this.getSteps()}
              onClick={this.handleClickStep}
              selectedStep={this.props.step}
            />
            {headerContent}
            <Content>{content}</Content>
            <SweetAlert {...this.props.alert} />
          </Container>
        </Background>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: userDetailSelector(state),
    userIsFetching: userDetailIsFetchingSelector(state),
    alert: alertSelector(state),
    step: currentStepSelector(state),
    params: paramsSelector(state),
    isSeating: isSeatingInWaysInSectorsSelector(state),
    firstWayId: firstWayConnectionIdSelector(state),
    secondWayId: secondWayConnectionIdSelector(state),
    connectionsById: connectionByIdSelector(state),
    isSectorFree: isFreeSeatingSelector(state),
    isSeatFree: seatingsSelector(state),
  };
};

App.propTypes = {
  alert: PropTypes.shape({}).isRequired,
  step: PropTypes.string.isRequired,
  isSeatFree: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isSectorFree: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dispatch: PropTypes.func.isRequired,
  isSeating: PropTypes.bool,
  location: PropTypes.shape({
    query: PropTypes.PropTypes.shape({}).isRequired,
  }).isRequired,
};

App.defaultProps = {
  isSeating: false,
};

export default connect(mapStateToProps)(withTheme(App));



// WEBPACK FOOTER //
// ./src/containers/App/index.js